module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "height2": "600px",
      "overflow-y2": "scroll"
    }
  }, [_c('Button', {
    staticStyle: {
      "border-radius": "3px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": _vm.newTaskOnClick
    }
  }, [_vm._v("Создать новую задачу")]), _vm._v(" "), _c('Row', [_c('Col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("Открытые")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "span",
      "options": _vm.dragOptions,
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = false
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.theBoardTasks),
      callback: function($$v) {
        _vm.theBoardTasks = $$v
      },
      expression: "theBoardTasks"
    }
  }, [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type2": "transition",
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.theBoardTasks), function(element) {
    return _c('li', {
      key: element.val.id,
      staticClass: "list-group-item",
      style: ({
        height: _vm.getTaskHeight(element)
      })
    }, [_c('i', {
      class: element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          element.fixed = !element.fixed
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(element.val.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.editTaskOnClick(element)
        }
      }
    }, [_c('Icon', {
      staticClass: "task-edit-icon",
      attrs: {
        "type": "more"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "badge",
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(element.val.id))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((element.val.body.checklist), function(checklistItem, indx) {
      return _c('div', {
        key: indx,
        staticStyle: {
          "width": "100%",
          "font-size": "12px",
          "margin-left": "30px",
          "margin-bottom": "3px",
          "float": "left"
        }
      }, [_vm._v("\n              " + _vm._s(checklistItem) + "\n            ")])
    }), _vm._v(" "), _c('draggable', {
      attrs: {
        "element": "span",
        "options": _vm.dragOptions,
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (element.subtasks),
        callback: function($$v) {
          element.subtasks = $$v
        },
        expression: "element.subtasks"
      }
    }, [_c('transition-group', {
      staticClass: "list-group2",
      attrs: {
        "type2": "transition",
        "name": "flip-list",
        "tag": "ul"
      }
    }, _vm._l((element.subtasks), function(element) {
      return _c('li', {
        key: element.val.id,
        staticClass: "list-group2-item",
        style: ({
          height: _vm.getTaskHeight(element)
        })
      }, [_c('i', {
        class: element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin',
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            element.fixed = !element.fixed
          }
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "left"
        }
      }, [_vm._v(_vm._s(element.val.name))]), _vm._v(" "), _c('span', {
        staticStyle: {
          "float": "right"
        },
        on: {
          "click": function($event) {
            _vm.editTaskOnClick(element)
          }
        }
      }, [_c('Icon', {
        staticClass: "task-edit-icon",
        attrs: {
          "type": "more"
        }
      })], 1), _vm._v(" "), _c('span', {
        staticClass: "badge",
        staticStyle: {
          "float": "right"
        }
      }, [_vm._v(_vm._s(element.val.id))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((element.val.body.checklist), function(checklistItem, indx) {
        return _c('div', {
          key: indx,
          staticStyle: {
            "width": "100%",
            "font-size": "12px",
            "margin-left": "30px",
            "margin-bottom": "3px",
            "float": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(checklistItem) + "\n                  ")])
      })], 2)
    }))], 1)], 2)
  }))], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("В работе")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "span",
      "options": _vm.dragOptions,
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": _vm.onEnd
    },
    model: {
      value: (_vm.list2),
      callback: function($$v) {
        _vm.list2 = $$v
      },
      expression: "list2"
    }
  }, [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type2": "transition",
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.list2), function(element) {
    return _c('li', {
      key: element.val.id,
      staticClass: "list-group-item",
      style: ({
        height: _vm.getTaskHeight(element)
      })
    }, [_c('i', {
      class: element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          element.fixed = !element.fixed
        }
      }
    }), _vm._v("\n              " + _vm._s(element.val.name) + "\n              "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(element.val.id))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((element.val.body.checklist), function(checklistItem, indx) {
      return _c('div', {
        key: indx,
        staticStyle: {
          "width": "100%",
          "font-size": "12px",
          "margin-left": "30px",
          "margin-bottom": "3px",
          "float": "left"
        }
      }, [_vm._v("\n                " + _vm._s(checklistItem) + "\n              ")])
    })], 2)
  }))], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "5px"
    }
  }, [_vm._v("Завершенные")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "element": "span",
      "options": _vm.dragOptions,
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.list3),
      callback: function($$v) {
        _vm.list3 = $$v
      },
      expression: "list3"
    }
  }, [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type2": "transition",
      "name": "flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.list3), function(element) {
    return _c('li', {
      key: element.val.id,
      staticClass: "list-group-item",
      style: ({
        height: _vm.getTaskHeight(element)
      })
    }, [_c('i', {
      class: element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          element.fixed = !element.fixed
        }
      }
    }), _vm._v("\n              " + _vm._s(element.val.name) + "\n              "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(element.val.id))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((element.val.body.checklist), function(checklistItem, indx) {
      return _c('div', {
        key: indx,
        staticStyle: {
          "width": "100%",
          "font-size": "12px",
          "margin-left": "30px",
          "margin-bottom": "3px",
          "float": "left"
        }
      }, [_vm._v("\n                " + _vm._s(checklistItem) + "\n              ")])
    })], 2)
  }))], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-692b7a4e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskBoard.vue
// module id = 401
// module chunks = 0